module.exports = __webpack_public_path__ + "static/media/ricardo.b5f8c29e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/ricardo.jpg
// module id = 1220
// module chunks = 0